<template>
  <div>
    <page-main
      ref="main"
      :table-data="table"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @groupClick="groupClick"
    >
      <pagination
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        size="small"
        align="right"
        slot="pager"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>

<script>
export default {
  name: 'resourceManagement-scm-appraisalItem',
  components: {
    PageMain: () => import('./components/main')
  },
  data() {
    return {
      table: [],
      loading: false,
      page: {
        curPage: 1,
        pageSize: 20,
        pageTotal: 0
      },
      param: {
        appraisalGroupCode: ''
      }
    }
  },
  activated() {
    this.handleSubmit()
  },
  methods: {
    // 点击左侧分组时查询
    groupClick(param) {
      this.reset()
      this.param = param
      this.handleSubmit()
    },
    reset() {
      this.page = {
        curPage: 1,
        pageSize: 20,
        pageTotal: 0
      }
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.$nextTick(() => {
        this.handleSubmit()
      })
    },
    // 重载表格数据
    reload() {
      this.handleSubmit()
    },
    // 加载表格数据
    handleSubmit() {
      this.loading = true
      this.$api
        .scmAppraisalItemListApi({
          itemStatus:'Y',
          ...this.page,
          ...this.param
        })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.table = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
